export default __webpack_public_path__ + "static/media/Allround.2ef732a5.svg";